import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// This function returns the settings for the editor
function getQuillModules(productId, handleImageUpload) {
  return {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ align: [] }],
        ["link", "image"],
        ["clean"]
      ],
      handlers: {
        image: () => handleImageUpload(productId)
      }
    }
  };
}

// ProductEditor component receives the product details and functions
const ProductEditor = ({ product, handleNotesChange, handleImageUpload, quillRef }) => {
  // useMemo keeps the modules object the same until product.id or handleImageUpload change
  const modules = useMemo(() => {
    return getQuillModules(product.id, handleImageUpload);
  }, [product.id, handleImageUpload]);

  return (
    <ReactQuill
      ref={quillRef}
      value={product.notes}
      onChange={(value) => handleNotesChange(product.id, value)}
      modules={modules}
      className="mb-4 bg-white border rounded"
    />
  );
};

export default ProductEditor;
